export default __webpack_public_path__ + "static/media/marauders-map-v1-02-02.2d390584.jpg";